import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useHasPolarisInPath = createRouterSelector(({ location }): boolean => {
	return location.pathname.includes('/jira/polaris');
});
